import { Alert, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { executeShellCommandJson, type ShellResponse } from '../../api/shell';
import { ResultTable } from '../../components/ResultTable';
import { sanitizeShellArg } from '../../utils/shell';

export function TaskInspector() {
  const [identifier, setIdentifier] = useState('');
  const [targetType, setTargetType] = useState('case_file');
  const [targetId, setTargetId] = useState('');
  const [result, setResult] = useState<ShellResponse | null>(null);
  const [listResult, setListResult] = useState<ShellResponse | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleGetTask() {
    if (!identifier.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await executeShellCommandJson(`task.get ${sanitizeShellArg(identifier)}`);
      setResult(res);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  }

  async function handleListTasks() {
    if (!targetType.trim() || !targetId.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await executeShellCommandJson(`task.list ${sanitizeShellArg(targetType)} ${sanitizeShellArg(targetId)}`);
      setListResult(res);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Stack spacing={3}>
      <Card sx={{ bgcolor: '#1a1d22' }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">Inspect Task</Typography>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Task name or ID"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                fullWidth
                size="small"
                placeholder="bootstrap-case-xxx or UUID"
              />
              <Button variant="contained" onClick={handleGetTask} disabled={loading}>
                Get
              </Button>
            </Stack>
            {result && <ResultTable data={result} />}
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ bgcolor: '#1a1d22' }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">List Tasks by Target</Typography>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Target type"
                value={targetType}
                onChange={(e) => setTargetType(e.target.value)}
                size="small"
                sx={{ width: 200 }}
              />
              <TextField
                label="Target ID"
                value={targetId}
                onChange={(e) => setTargetId(e.target.value)}
                fullWidth
                size="small"
                placeholder="case UUID"
              />
              <Button variant="contained" onClick={handleListTasks} disabled={loading}>
                List
              </Button>
            </Stack>
            {listResult && <ResultTable data={listResult} />}
          </Stack>
        </CardContent>
      </Card>

      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
